import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { createRouter, RouterProvider } from "@tanstack/react-router";
import { QueryClientProvider } from "@tanstack/react-query";
import { ThemeProvider } from "@/providers/theme-provider";
import { PostHogProvider } from "@/providers/posthog-provider";
import { AuthProvider } from "@/components/auth/AuthProvider";
import { telemetry } from "@/services/telemetry";
import { initializeApiMonitoring } from "@/services/api-interceptors";
import { queryClient } from "@/services/queryClient";
import "@/styles/globals.css";
import { routeTree } from "./routeTree.gen";
//noop
// Initialize Application Insights telemetry
const appInsightsConnectionString = import.meta.env.VITE_APPLICATIONINSIGHTS_CONNECTION_STRING;
if (appInsightsConnectionString) {
  telemetry.initialize(appInsightsConnectionString);
  initializeApiMonitoring();
} else {
  console.log("Application Insights connection string not configured");
}

// Create a new router instance
const router = createRouter({ routeTree });

// Register the router instance for type safety
declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

// Global hook to clear client-side caches on logout
if (typeof window !== "undefined") {
  window.addEventListener("app:auth-clear-cache", () => {
    queryClient.clear();
  });
}

const rootElement = document.getElementById("root")!;
createRoot(rootElement).render(
  <StrictMode>
    <PostHogProvider>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider>
          <AuthProvider>
            <RouterProvider router={router} />
          </AuthProvider>
        </ThemeProvider>
      </QueryClientProvider>
    </PostHogProvider>
  </StrictMode>,
);
